import { useState, useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './app/router';
import { useAuthInit } from '@/features/auth/hooks/useAuthInit';
import { Toaster } from '@/shared/components/custom/toast';
import { useUIStore } from '@/core/stores/ui.store';

const SYSTEM_DARK_MQ = '(prefers-color-scheme: dark)';

function useToasterConfig() {
  const storeTheme = useUIStore((s) => s.theme);
  const [systemDark, setSystemDark] = useState(() => window.matchMedia(SYSTEM_DARK_MQ).matches);

  useEffect(() => {
    if (storeTheme !== 'system') return;
    const mq = window.matchMedia(SYSTEM_DARK_MQ);
    const handler = (e: MediaQueryListEvent) => setSystemDark(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [storeTheme]);

  const isDark = storeTheme === 'dark' || (storeTheme === 'system' && systemDark);

  return {
    // sileo 'light' = white description text (for dark pill = light mode)
    // sileo 'dark'  = dark description text  (for light pill = dark mode)
    sileoTheme: (isDark ? 'dark' : 'light') as 'light' | 'dark',
  };
}

function App() {
  useAuthInit();
  const { sileoTheme } = useToasterConfig();

  return (
    <>
      <Toaster
        position="top-center"
        theme={sileoTheme}
        options={{ duration: 4000 }}
        offset={{ top: 56 }}
      />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
